import { Validators } from '@angular/forms';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';

export const divestment_isp_form_template = {
  amount: '0',
};

export const divestment_isp_form_validators = {
  amount: [Validators.required, Validators.pattern(/^\d+(\,\d+)?$/)],
};

export const DIVESTMENT_LIFE_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
  {
    key: 'description',
    label: 'Nome fondo',
  },
  {
    key: 'fundAmount',
    label: 'Importo fondo (€)',
  },

  {
    key: 'amount',
    label: 'Importo da disinvestire (€)',
  },
];

export const DIVESTMENT_PREVIDENTIAL_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
  {
    key: 'selected',
    label: '',
    type: 'RADIO',
  },
  {
    key: 'description',
    label: 'Nome fondo',
  },
  {
    key: 'quoteNumber',
    label: 'Quote',
  },
  {
    key: 'fundAmount',
    label: 'Importo fondo (€)',
  },
  {
    key: 'quoteValue',
    label: 'Quotazione',
  },
  {
    key: 'quoteValueUpdateDate',
    label: 'Data Nav',
  },
];

export const DIVESTMENT_FUNDS_REDIRECTION_TABLE_KEYS: ITableKey[] = [
  {
    key: 'description',
    label: 'Fondo',
  },
  {
    key: 'subscriberAllocation',
    label: 'Iscritto (%)',
  },
  {
    key: 'companyAllocation',
    label: 'Datore di Lavoro (%)',
  },
  {
    key: 'TFRAllocation',
    label: 'TFR (%)',
  },
];
